export default __webpack_public_path__ + "static/media/edit.933d93f6.svg";